import { setCookie } from './utils/cookie'
function goWithoutAuth () {
  if (document.querySelector('[data-js-without-auth]')) {
    document.querySelector('[data-js-without-auth]').addEventListener('click', () => {
      const week = 604800
      setCookie('withoutAuth', true, { expires: week, path: '/' })
    })
  }
}

export { goWithoutAuth }
